// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__39sKS","delete":"styles_delete__2h3f8","update":"styles_update__SaAv3","add":"styles_add__2dicq"};